module.exports = __webpack_public_path__ + "static/img/column_recommendation2_2.4dbd91db.png";